import routerOptions0 from "/builds/void-zero/clients/mijn-epd/node_modules/.pnpm/nuxt@4.4.7_@babel+plugin-syntax-jsx@7.27.1_@babel+core@7.29.7__@babel+plugin-syntax-typ_0c8c5a4e9e9cd6ee66ba4a6aa9082718/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}